/*
 *   File :  viewMessageContent.js
 *   Author URI : https://evoqueinnovativelab.com
 *   Description : Message content
 *   Integrations :
 *   Version : v1.0
 */

/*import packages*/
import React, { useState, useEffect } from 'react';

import styles from '../../styles/components/viewMessage.module.scss';
import { SecondaryBtn } from '../cta';
import { isWebinarData, getWebinarHeaderFromData, getWebinarUrlFromData, getWebinarContentsFromData } from '../../config/webinarTemplate';
import WebinarPreview from '../notification/webinarPreview';
import { prependEmailBanner, getEmailImageUrlFromData, prepareHtmlForPreview } from '../../config/emailTemplate';


export default function ViewMessageContent(props) {

    const [htmlFile, setHtmlFile] = useState(null);

    useEffect(() => {
        const emailData = props.data?.contents?.email_data;
        if (emailData?.email_type === "HTML_CONTENT" && emailData?.html_content) {
            fetch(emailData.html_content)
                .then(res => res.text())
                .then(data => setHtmlFile(
                    prependEmailBanner(
                        prepareHtmlForPreview(data),
                        getEmailImageUrlFromData(emailData)
                    )
                ));
        } else {
            setHtmlFile(null);
        }
    }, [props.data]);

    function _handleCloseModal() {
        props.closeModal();
    }

    function _deleteContent() {
        document.getElementById("close-pscm").dispatchEvent(new Event("click"));
        props.deleteMessage(props.data.id);
    }

    function _openEditMessage() {
        console.log('daaada')
        document.getElementById("close-pscm").dispatchEvent(new Event("click"));
        props.editMessage(props.data);
    }

    async function getFileDetails(url) {
        // Extract file name
        const cleanUrl = url.split("?")[0];
        const fileName = cleanUrl.substring(cleanUrl.lastIndexOf("/") + 1);

        // Extract extension
        const extension = cleanUrl.split(".").pop().toLowerCase();

        // Type mappings
        const imageExt = ["jpg", "jpeg", "png", "gif", "webp", "svg"];
        const videoExt = ["mp4", "mov", "webm", "mkv"];
        const audioExt = ["mp3", "wav", "ogg"];
        const pdfExt = ["pdf"];
        const docExt = ["doc", "docx", "xls", "xlsx", "csv", "pdf"];

        // 1 → image
        if (imageExt.includes(extension)) return { type: 1, fileName };

        // 2 → video
        if (videoExt.includes(extension)) return { type: 2, fileName };

        // 3 → audio
        if (audioExt.includes(extension)) return { type: 3, fileName };

        // 4 → pdf
        if (pdfExt.includes(extension)) return { type: 5, fileName };

        // 5 → docs
        if (docExt.includes(extension)) return { type: 5, fileName };

        // If extension missing → try HEAD request
        try {
            const response = await fetch(url, { method: "HEAD" });
            const contentType = response.headers.get("content-type");

            if (!contentType) return { type: 0, fileName };

            if (contentType.startsWith("image/")) return { type: 1, fileName };
            if (contentType.startsWith("video/")) return { type: 2, fileName };
            if (contentType.startsWith("audio/")) return { type: 3, fileName };
            if (contentType === "application/pdf") return { type: 4, fileName };
            if (
                contentType.includes("word") ||
                contentType.includes("excel") ||
                contentType.includes("presentation")
            ) return { type: 5, fileName };

            return { type: 0, fileName }; // unknown
        } catch (error) {
            return { type: 0, fileName }; // unknown
        }
    }

    const FileRenderer = ({ url }) => {
        const [info, setInfo] = useState({ type: 0, fileName: "" });

        useEffect(() => {
            if (url) {
                getFileDetails(url).then(res => setInfo(res));
            }
        }, [url]);

        if (info.type === 1)
            return <img src={url} width="100%" height="100%" style={{ objectFit: "contain" }} />;

        if (info.type === 2)
            return <video src={url} width="100%" height="100%" controls style={{ objectFit: "contain" }} />;

        if (info.type === 3)
            return <audio controls src={url} />;

        if (info.type === 4)
            return <iframe src={url} width="100%" height="300px" title="PDF Preview" />;

        if (info.type === 5)
            return <a href={url} target="_blank" rel="noreferrer">{info.fileName}</a>;

        return <p>Unsupported file</p>;
    };


    function convertWhatsAppToHtml(text) {
        if (!text) return "";

        let html = text;

        html = html.replace(/\*_\s*(.+?)\s*_\*/g, "<strong><em>$1</em></strong>");
        html = html.replace(/\*(.+?)\*/g, "<strong>$1</strong>");
        html = html.replace(/_\s*(.+?)\s*_/g, "<em>$1</em>");
        html = html.replace(/~\s*(.+?)\s*~/g, "<s>$1</s>");

        return html.replace(/\n/g, "<br>");
    }

    return (
        <div className={`${styles.e_view_content} modal fade`}
            id={"view-message-content"}
            tabIndex="-1"
            data-bs-backdrop="static"
            aria-labelledby="view-message-content"
            aria-hidden="true">
            <div className={`${styles.e_modal_dialog} modal-dialog modal-dialog-centered`}>
                <div className={`${styles.e_content} modal-content `}>
                    <div className='d-flex justify-content-between pt-2'>
                        <h4>{props.data?.channel_variable || props.data?.type} detail</h4>
                        <button id="close-pscm"
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            onClick={_handleCloseModal} >
                        </button>
                    </div>

                    <div className={styles.e_body}>

                        {
                            props.data?.message_detail?.channel === 3 ?
                                <div className='row'>
                                    <div className='col-12 d-flex algin-items-center py-3'>
                                        <h6 className='mb-0'>{props.data?.contents?.email_data?.subject}</h6>
                                        {
                                            props.data?.scheduled_date &&
                                            <div className={styles.e_tag}>
                                                Scheduled
                                            </div>
                                        }
                                    </div>

                                    <div className={styles.scroll_container}>
                                        <div className='col-12'>
                                            {
                                                props.data?.contents?.email_data?.email_type === "BODY_CONTENT" ?
                                                    <div
                                                        className={styles.e_html}
                                                        dangerouslySetInnerHTML={{
                                                            __html: prependEmailBanner(
                                                                props.data?.contents?.email_data?.email_body || '',
                                                                getEmailImageUrlFromData(props.data?.contents?.email_data)
                                                            )
                                                        }}
                                                    />
                                                    :
                                                    <div className={styles.e_html}
                                                        dangerouslySetInnerHTML={{ __html: htmlFile }}
                                                    />
                                            }
                                        </div>

                                        {
                                            props.data?.contents?.email_data?.email_attachment?.length ? 
                                            <h5 className={`my-3 ${styles.e_label}`}>Attachments</h5>
                                            : null
                                        }
                                        {
                                            props.data?.contents?.email_data?.email_attachment?.length ?
                                            props.data?.contents?.email_data?.email_attachment.map((item, key) => {
                                                return (
                                                    <div className='col-12 mb-3 border-bottom pb-4' style={{ height: '200px' }} key={key}>
                                                        <FileRenderer url={item} />
                                                    </div>
                                                )
                                            })
                                            :
                                            null

                                        }
                                        <div className='col-12'>
                                            <p className={styles.e_p_tag}>Created on . {props.data?.created},
                                                {
                                                    props.data?.scheduled_date ?
                                                        <>
                                                            {' Scheduled for . ' + props.data?.scheduled_date},
                                                            {' Message frequency . ' + props.data?.message_detail?.frequency_var}
                                                        </>
                                                        : null
                                                }

                                            </p>
                                        </div>
                                    </div>
                                    {
                                        props.tabIndex === 1 ?
                                            <div className='col-12 d-flex py-3'>
                                                <SecondaryBtn name="Delete"
                                                    handleClick={_deleteContent}
                                                    className={`e-delete-btn-msg  me-2`} />
                                                <SecondaryBtn name="Edit"
                                                    handleClick={_openEditMessage}
                                                    className={styles.e_edit} />
                                            </div>
                                            :
                                            null
                                    }

                                </div>
                                :
                                props.data?.message_detail?.channel === 2 ?
                                    <div className='row'>
                                        <div className='col-12 d-flex algin-items-center py-3'>
                                            <h5 className={`mb-0 ${styles.e_editor_data}`}
                                                dangerouslySetInnerHTML={{
                                                    __html: props.data?.title
                                                }} />
                                            {
                                                props.data?.scheduled_date &&
                                                <div className={styles.e_tag}>
                                                    Scheduled
                                                </div>
                                            }
                                        </div>

                                        <div className={styles.scroll_container}>
                                            {(() => {
                                                const wData = props.data?.contents?.whatsapp_data;
                                                // webinar_invite: reuse the same shared renderer as the
                                                // send/compose preview (no duplicated markup).
                                                if (isWebinarData(wData)) {
                                                    return (
                                                        <div className='e-whatsapp-chat-box e-webinar-modal-preview'>
                                                            <div className='e-chatbox e-chatbox-webinar'>
                                                                <WebinarPreview
                                                                    image={getWebinarHeaderFromData(wData)}
                                                                    url={getWebinarUrlFromData(wData)}
                                                                    contents={getWebinarContentsFromData(wData)}
                                                                />
                                                            </div>
                                                        </div>
                                                    );
                                                }
                                                return (
                                                    <>
                                                        <p className={`mb-0 ${styles.e_editor_data}`}
                                                            dangerouslySetInnerHTML={{
                                                                __html: convertWhatsAppToHtml(wData?.content)
                                                            }} />
                                                        {
                                                            wData?.content_one ?
                                                                <p className={`mb-0 ${styles.e_editor_data}`}
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: convertWhatsAppToHtml(wData?.content_one)
                                                                    }} />
                                                                :
                                                                null
                                                        }
                                                    </>
                                                );
                                            })()}

                                            {
                                                (() => {
                                                    const wData = props.data?.contents?.whatsapp_data;
                                                    if (!wData) return null;
                                                    // webinar preview (incl. header) is rendered above; skip
                                                    // the generic attachment list for the webinar template.
                                                    if (isWebinarData(wData)) return null;

                                                    // Normalize attachments
                                                    const images = Array.isArray(wData.images) ? wData.images : [];
                                                    const videos = Array.isArray(wData.videos) ? wData.videos : [];
                                                    const docs = Array.isArray(wData.doc) ? wData.doc : (wData.doc ? [wData.doc] : []);

                                                    // Pick whichever exists first (image → video → doc)
                                                    let attachments = [];

                                                    if (images.length) {
                                                        attachments = images
                                                            .filter(item => item?.image)
                                                            .map(item => item.image);
                                                    } else if (videos.length) {
                                                        attachments = videos
                                                            .filter(item => item?.video)
                                                            .map(item => item.video);
                                                    } else if (docs.length) {
                                                        attachments = docs.filter(item => item);
                                                    }

                                                    if (!attachments.length) return null;

                                                    return (
                                                        <>
                                                            <h5 className={`my-3 ${styles.e_label}`}>Attachments</h5>

                                                            {attachments.map((url, i) => (
                                                                <div
                                                                    key={i}
                                                                    className="col-12 mb-3 border-bottom pb-4"
                                                                    style={{ height: "200px" }}
                                                                >
                                                                    <FileRenderer url={url} />
                                                                </div>
                                                            ))}
                                                        </>
                                                    );
                                                })()
                                            }

                                            <div className='col-12'>
                                                <p className={styles.e_p_tag}>Created on . {props.data?.created},

                                                    {
                                                        props.data?.scheduled_date ?
                                                            <>
                                                                {' Scheduled for . ' + props.data?.scheduled_date},
                                                                {' Message frequency . ' + props.data?.message_detail?.frequency_var}
                                                            </>
                                                            : null
                                                    }

                                                </p>
                                            </div>
                                        </div>
                                        {
                                            props.tabIndex === 1 ?
                                                <div className='col-12 d-flex py-3'>
                                                    <SecondaryBtn name="Delete"
                                                        handleClick={_deleteContent}
                                                        className={`e-delete-btn-msg  me-2`} />
                                                    <SecondaryBtn name="Edit"
                                                        handleClick={_openEditMessage}
                                                        className={styles.e_edit} />
                                                </div>
                                                :
                                                null
                                        }
                                    </div>
                                    :
                                    <div className='row'>
                                        <div className='col-12 d-flex algin-items-center py-3'>
                                            <h6 className='mb-0'>{props.data?.title}</h6>
                                            {
                                                props.data?.scheduled_date &&
                                                <div className={styles.e_tag}>
                                                    Scheduled
                                                </div>
                                            }
                                        </div>

                                        <div className={styles.scroll_container}>

                                            {props.data?.contents?.notification_data?.message != null && props.data.contents.notification_data.message !== '' && (
                                                <div className={`col-12 ${styles.e_html}`}
                                                    dangerouslySetInnerHTML={{ __html: props.data.contents.notification_data.message || '' }}
                                                />
                                            )}

                                            {props.data?.contents?.notification_data?.long_description != null && props.data.contents.notification_data.long_description !== '' && (
                                                <div className={`col-12 ${styles.e_html}`}
                                                    dangerouslySetInnerHTML={{ __html: props.data.contents.notification_data.long_description || '' }}
                                                />
                                            )}

                                            {props.data?.contents?.notification_data?.image && (
                                                <div className='col-12 mb-3 border-bottom pb-4' style={{ height: '200px' }} >
                                                    <img src={props.data.contents.notification_data.image}
                                                        height="100%"
                                                        width="100%"
                                                        style={{ objectFit: "contain" }}
                                                        alt="" />
                                                </div>
                                            )}
                                            <div className='col-12'>
                                                <p className={styles.e_p_tag}>Created on . {props.data?.created}

                                                    {
                                                        props.data?.scheduled_date ?
                                                            <>
                                                                {' Scheduled for . ' + props.data?.scheduled_date},
                                                                {' Message frequency . ' + props.data?.message_detail?.frequency_var}
                                                            </>
                                                            : null
                                                    }

                                                </p>
                                            </div>
                                        </div>
                                        {
                                            props.tabIndex === 1 ?
                                                <div className='col-12 d-flex py-3'>
                                                    <SecondaryBtn name="Delete"
                                                        handleClick={_deleteContent}
                                                        className={`e-delete-btn-msg  me-2`} />
                                                    <SecondaryBtn name="Edit"
                                                        handleClick={_openEditMessage}
                                                        className={styles.e_edit} />
                                                </div>
                                                :
                                                null
                                        }
                                    </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}